import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  private baseUrl:any = environment.baseUrl;


  constructor
   (     private http: HttpClient,
         private socketService: SocketService 
         

    ) { 

  }

  getAccessTokens():Observable<any>{
     return this.http.get(`${this.baseUrl}` + '/api/v1/user/accessTokens');
  }
  
  generateAccessToken(title: string,email: string,username: string): void {
    this.socketService.socket.emit('user.keys.accessToken.generate', {
      'title':title,
      'email':email,
      'name':username
    });
  }

  removeAccessToken(title){
    this.socketService.socket.emit('user.keys.accessToken.remove', {
      title: title
    })
  
    // this.socketService.socket.on('user.keys.accessToken.updated', (data: any) => {

      
    // })

  }
displayTokenKey(email :any){


return this.http.get(`${this.baseUrl}`+'/api/v1/automation/getAccessToken/'+email+'/')
  
}

  // http://localhost:7110/?uip=%3A%3Affff%3A127.0.0.1
  // socket.on('user.keys.accessToken.generated', function(token) {
  //   $rootScope.$broadcast('user.keys.accessTokens.generated', token)
  //   $rootScope.$apply()
  // })


}

  



  


